// HeatMapZones.jsx
import { useMemo, useState } from "react";
import { Source, Layer, Popup } from "react-map-gl";

const HeatMapZones = ({ palms = [], tileset }) => {
  const [selectedPalm, setSelectedPalm] = useState(null);


  const colorCero = "#ff0000" 
  const colorOne = "#FF8000" 
  const colorTwo = "#FFFF66"
  const colorThree = "#80DFFF"
  const colorFour = "#3333FF"

  const features = useMemo(() => {
    if (!Array.isArray(palms)) return [];
    return palms.reduce((acc, p) => {
      const coords = p?.location?.coordinates;
      const lon = Number(coords?.[0]);
      const lat = Number(coords?.[1]);
      if (Number.isFinite(lon) && Number.isFinite(lat)) {
        acc.push({
          type: "Feature",
          geometry: { type: "Point", coordinates: [lon, lat] },
          properties: {
            weight: p?.totalFirstApplications ?? 0, // usamos esto como "peso"
            palmName: p?.palmName,
            lotName: p?.lotName,
            lineName: p?.lineName,
          },
        });
      }
      return acc;
    }, []);
  }, [palms]);

  const geojson = useMemo(
    () => ({
      type: "FeatureCollection",
      features,
    }),
    [features]
  );


 

  // 🔥 Estilo heatmap
  const heatmapLayer = {
    id: "palms-heatmap",
    type: "heatmap",
    source: "palms",
    maxzoom: 22,
    paint: {
      // intensidad según el peso
      "heatmap-weight": ["interpolate", ["linear"], ["get", "weight"], 0, 0, 5, 1],
      // escala de intensidad con zoom
      "heatmap-intensity": ["interpolate", ["linear"], ["zoom"], 0, 1, 15, 3],
      // colores
      "heatmap-color": [
        "interpolate",
        ["linear"],
        ["heatmap-density"],
        0, "rgba(0,0,255,0)",   // transparente
        0.25, colorOne,
        0.5, colorTwo,
        0.75, colorThree,
        1, colorFour
      ],
      // radio de influencia
      "heatmap-radius": ["interpolate", ["linear"], ["zoom"], 0, 2, 15, 17],
      // opacidad general
      "heatmap-opacity": 0.8,
    },
  };

  if (features.length === 0) return null;

  return (
    <>

    {tileset && (
        <>
          <Source
            id="ortomosaico"
            type="raster"
            url={`mapbox://${tileset}`}
            tileSize={256}
          />
          <Layer
            id="ortomosaico-layer"
            type="raster"
            source="ortomosaico"
            paint={{ "raster-opacity": 1 }}
          />
        </>
      )}

      <Source id="palms" type="geojson" data={geojson}  beforeId="ortomosaico-layer" >
        <Layer {...heatmapLayer} />
      </Source>
    </>
  );
};

export default HeatMapZones;
